import * as Hooks from 'preact/hooks';
import * as O from 'fp-ts/Option';
import { pipe } from 'fp-ts/function';
import { Interface } from '../../arya/interface';

export function useFurnitureLoadingState(
    aryaRef: O.Option<Interface>,
    alert: { open: (message: string) => void },
) {
    const [loadingFurnitureName, setLoadingFurnitureName] = Hooks.useState<string>('');
    const [loadingFurnitureId, setLoadingFurnitureId] = Hooks.useState('');
    Hooks.useEffect(() => {
        if (loadingFurnitureId !== '') {
            const checkReady = setInterval(() => {
                pipe(
                    aryaRef,
                    O.chain(arya => arya.furnitureReady(loadingFurnitureId)),
                    O.map(ready => {
                        if (ready === true) {
                            alert.open('Item Added');
                            setLoadingFurnitureId('');
                            setLoadingFurnitureName('');
                        }
                    }),
                );
            }, 300);

            return () => clearInterval(checkReady);
        }
    }, [loadingFurnitureId]);
    return {
        loadingFurnitureName,
        setLoadingFurnitureName,
        setLoadingFurnitureId,
    };
}
